import a from "./_getMapData.js";
function r(t) {
  return a(this, t).get(t);
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapCacheGet.js
// module id = 1491
// module chunks = 41